<template>
  <div class="container">
    <p style="text-align: center">
      <span style="font-size: 24px; font-weight: 700">隐私政策</span>
    </p>

    <p><strong>引言</strong></p>
    <p>
      本平台（“我们”）深知个人信息对您的重要性，我们将采取相应的安全保护措施，尽力保护您的个人信息安全可控。本隐私政策（以下简称“本政策”）旨在向您说明，在您使用我们的产品与/或服务时，我们如何收集、使用、保存、共享和转让您的个人信息，以及您所享有的相关权利。
    </p>
    <p>
      请您在使用本平台前，仔细阅读并充分理解本政策。一旦您开始使用本平台，即表示您已充分理解并同意我们按照本政策收集、使用、存储和共享您的个人信息。如果您不同意本政策的任何内容，请立即停止使用本平台。
    </p>

    <p>本政策将帮助您了解以下内容：</p>
    <p>我们如何收集和使用您的个人信息</p>
    <p>我们如何使用Cookie和同类技术</p>
    <p>我们如何共享、转让、公开披露您的个人信息</p>
    <p>我们如何存储和保护您的个人信息</p>
    <p>您的权利</p>
    <p>我们如何处理未成年人的个人信息</p>
    <p>本政策的更新与通知</p>
    <p>如何联系我们</p>

    <p><strong>一、我们如何收集和使用您的个人信息</strong></p>
    <p>
      我们会遵循合法、正当、必要和诚信的原则，出于向您提供本平台服务的目的，收集和使用您在使用服务过程中主动提供或因服务需要而产生的个人信息。
    </p>

    <p><strong>（一）基本功能所需的必要信息</strong></p>
    <p>
      当您使用本平台的核心功能（如注册登录、浏览、下单、支付等）时，我们需要收集以下必要信息，否则您无法使用该等基本功能：
    </p>
    <p>
      <strong>注册与登录</strong><br>
      必要信息：您的手机号码、或电子邮箱地址（用于创建账户、验证身份、接收通知）。您也可以选择使用第三方账号（如微信、QQ）登录，此时我们会获取您在该第三方账号下的公开信息（如昵称、头像、地区等）。<br>
      账户信息：您设置的登录密码、头像、昵称等。
    </p>
    <p>
      <strong>商品/服务展示与搜索</strong><br>
      设备信息：我们会收集您的设备型号、操作系统版本、唯一设备标识符（如IMEI/OAID）、IP地址、浏览器类型、Wi-Fi网络信息（包括BSSID、SSID）等信息，用于向您展示更符合您设备适配性的商品页面，以及识别网络环境、保障账号与交易安全。
日志信息：当您使用本平台时，我们会自动收集您的浏览记录、点击记录、搜索关键词、访问时长、商品收藏/分享记录等，以优化商品推荐和排序。
    </p>
    <p>
      <strong>下单与交易</strong><br>
      收货信息：为完成商品配送，您需要提供收货人姓名、收货地址、联系电话。<br>
      订单信息：您购买的商品/服务明细、订单号、交易金额、下单时间、支付状态。<br>
      支付信息：为完成支付，我们会将您的订单号、交易金额等必要信息共享给第三方支付机构（如支付宝、微信支付）。我们不会直接收集您的银行卡密码或支付密码，但会获取支付结果信息。
    </p>
    <p>
      <strong>交付与物流</strong><br>
      为了向您交付商品，我们会将您的订单信息、收货人姓名、收货地址、联系电话共享给合作的物流服务商（如顺丰、中通等）。
    </p>
    <p>
      <strong>客服与售后</strong><br>
      沟通记录：当您与我们的客服联系或发起售后申请时，我们会收集您提供的聊天记录、通话录音（仅用于纠纷判定及培训，会事先告知）、售后申请内容、图片/视频凭证等。<br>
      必要核验信息：在某些情况下（如申请退换货、修改关键信息），我们可能会要求您提供身份信息进行核验。
    </p>

    <p>
      <strong>关于Wi-Fi网络信息（BSSID、SSID）的特别说明：</strong><br>
      为识别您当前的网络环境、判断网络连接状态、防范账号盗用及交易欺诈等安全风险，我们可能会收集您所连接Wi-Fi网络的BSSID（基本服务集标识符）和SSID（服务集标识符）。
      • 收集目的：网络环境识别、账号安全风控、交易安全保障。
      • 收集方式：通过系统API在您使用本平台服务时自动获取。
      • 收集范围：仅收集当前已连接Wi-Fi网络的BSSID和SSID信息，不涉及Wi-Fi密码或其他网络数据。
    </p>

    <p><strong>（二）附加功能所需的非必要信息</strong></p>
    <p>
      您可以自主选择是否开启以下附加功能，拒绝提供不影响您使用基本功能：
    </p>
    <p>
      评论/晒图功能：当您对商品发表评价或晒图时，我们会收集您发布的内容（包括文字、图片、视频）。请注意，这些内容将是公开的。<br>
      地理位置功能：如果您使用“附近的门店”、“收货地址自动定位”等功能，我们会请求您授权地理位置权限，以获取您的精确位置信息。<br>
      相册/相机功能：当您使用扫码、拍照晒图、上传头像、联系客服上传图片时，我们会请求您授权相机或相册权限。<br>
      消息推送功能：我们会收集您的设备信息，用于向您发送订单状态、促销活动等推送通知。您可以在设备设置中关闭此权限。<br>
      社交分享功能：当您将商品分享至微信、朋友圈等外部平台时，我们会收集您的分享记录。
    </p>

    <p><strong>（三）例外情况（无需征得您授权同意的情形）</strong></p>
    <p>
      根据相关法律法规，以下情形中我们处理个人信息无需征得您的同意：<br>
      1. 为订立、履行您作为一方当事人的合同所必需；<br>
      2. 为履行法定职责或者法定义务所必需；<br>
      3. 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br>
      4. 依法在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；<br>
      5. 法律、行政法规规定的其他情形。
    </p>

    <p><strong>二、我们如何使用Cookie和同类技术</strong></p>
    <p>
      2.1 为确保本平台正常运转，我们会在您的设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。我们使用Cookie来：<br>
      - 让您保持登录状态，避免重复输入密码；<br>
      - 记录您的购物车信息；<br>
      - 了解您的浏览习惯，为您提供个性化的商品展示。
    </p>
    <p>
      2.2 您可以通过浏览器设置拒绝或管理Cookie。但请注意，如果停用Cookie，您可能无法使用依赖Cookie的某些服务（如自动登录、购物车等）。
    </p>

    <p><strong>三、我们如何共享、转让、公开披露您的个人信息</strong></p>
    <p><strong>（一）共享</strong></p>
    <p>
      我们不会与平台以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：<br>
      1. 与第三方服务提供者的共享：为实现本平台的核心功能，我们可能会与以下类型的第三方共享您的必要信息：<br>
      物流服务商：共享收货人姓名、地址、电话，用于完成配送。<br>
      支付机构：共享订单号、交易金额，用于完成支付。<br>
      技术服务商：共享设备信息、日志信息，用于提升系统稳定性和安全性。<br>
      营销服务商（如您同意）：共享脱敏后的用户画像数据，用于推送个性化广告。<br>
      2. 与关联公司或商家的共享：<br>
      为实现您与商家的交易，我们会将您的订单信息、部分账户信息共享给您购买商品所在的具体商家。<br>
      如我们与关联公司共同为您提供服务，我们可能会在关联公司内部共享必要信息。<br>
      3. 法定情形下的共享：根据法律法规、诉讼、政府调查等要求，我们可能会向有权机关共享您的个人信息。
    </p>

    <p><strong>（二）转让</strong></p>
    <p>
      我们不会将您的个人信息转让给任何公司、组织或个人，但以下情况除外：<br>
      1. 获得您的明确同意后；<br>
      2. 在涉及合并、收购、资产转让或破产清算时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求其重新获得您的授权同意。
    </p>

    <p><strong>（三）公开披露</strong></p>
    <p>
      我们仅会在以下情况下，公开披露您的个人信息：<br>
      1. 获得您的单独同意；<br>
      2. 基于法律、司法或行政程序的强制性要求。
    </p>

    <p><strong>四、我们如何存储和保护您的个人信息</strong></p>
    <p>
      4.1 存储地点：我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。我们不会将您的个人信息传输至境外。
    </p>
    <p>
      4.2 存储期限：我们仅在为实现本政策所述目的所必需的最短期限内保留您的个人信息，除非法律法规另有规定（例如《电子商务法》要求交易信息保存不少于3年）。超出期限后，我们将对您的个人信息进行删除或匿名化处理。
    </p>
    <p>
      4.3 保护措施：<br>
      技术层面：我们采用符合行业标准的加密技术（如SSL/TLS）、防火墙、数据脱敏、访问控制等措施，防止数据被非法访问、泄露、篡改或丢失。<br>
      管理层面：我们建立内部个人信息保护制度，对员工进行数据安全培训，并与员工签署保密协议。
    </p>
    <p>
      4.4 安全提醒：尽管我们已采取上述措施，但互联网环境并非绝对安全。您应妥善保管您的账户密码，避免向他人泄露。如发现个人信息泄露，请立即联系我们。
    </p>

    <p><strong>五、您的权利</strong></p>
    <p>
      根据法律法规，您对您的个人信息享有以下权利：
    </p>
    <p>
      5.1 查阅与更正：您可以通过“我的” → “账户设置”页面，查看和修改您的头像、昵称、性别、收货地址、手机号码等基本信息。
    </p>
    <p>
      5.2 删除：在以下情形下，您可以向我们提出删除个人信息的请求：<br>
      - 我们处理个人信息的行为违反法律法规；<br>
      - 我们未征得您同意收集、使用您的个人信息；<br>
      - 我们违反本政策约定向第三方共享您的个人信息；<br>
      - 您注销账户。
    </p>
    <p>
      5.3 改变授权范围：您可以通过设备系统设置或本平台内的“隐私设置”来关闭部分权限（如位置、相机、相册）。关闭后，我们将不再收集该部分信息。
    </p>
    <p>
      5.4 注销账户：您可以通过“我的” → “账户与安全” → “注销账户”来申请注销您的账户。请注意，账户注销是不可逆的，我们将停止为您提供服务，并依据适用法律删除或匿名化您的个人信息。
    </p>
    <p>
      5.5 撤回同意：对于基于您的同意而进行的个人信息处理活动（如营销推送），您有权随时撤回同意。撤回后，我们将不再处理相应的个人信息。
    </p>
    <p>
      5.6 响应您的请求：您可以通过本政策第八条的渠道联系我们行使上述权利。我们将在15个工作日内回复。如无正当理由，我们不会向您收取费用。如您的请求超出合理限度，或需要过多技术投入，我们可能会酌情收取成本费用或拒绝处理。
    </p>

    <p><strong>六、我们如何处理未成年人的个人信息</strong></p>
    <p>
      6.1 本平台主要面向成年人。如果您是14周岁以下的儿童，在使用本平台前，必须取得您的法定监护人的明确同意。
    </p>
    <p>
      6.2 对于经监护人同意而收集的儿童个人信息，我们将在法律允许的范围内，采取更严格的保护措施。如发现未经监护人同意而收集了儿童个人信息，我们将尽快删除。
    </p>

    <p><strong>七、本政策的更新与通知</strong></p>
    <p>
      7.1 本政策可能会根据法律法规变化、业务调整或用户需求进行更新。我们将在本平台上公布更新后的政策，并在生效前通过弹窗、站内信、短信等显著方式通知您。
    </p>
    <p>
      7.2 如您不同意更新后的政策，您有权停止使用本平台。如您继续使用，则视为您同意更新后的政策。
    </p>

    <p><strong>八、如何联系我们</strong></p>
    <p>
      如您对本政策有任何疑问、意见或投诉，或者希望行使您的个人信息权利，可以通过以下方式联系我们：<br>
      个人信息保护负责人邮箱：dggj@123-ai.cn<br>
      客服热线：18012695828
    </p>
    <p>
      我们将在收到您请求后的15个工作日内完成处理。如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您可以向网信、工信、公安、市场监管等监管部门进行投诉或举报，或向有管辖权的法院提起诉讼。
    </p>
    <p>发布日期：2026年6月10日</p>
    <p>生效日期：2026年6月14日</p>
    <p>更新日期：2026年6月12日</p>
  </div>
</template>

<script>
export default {
  name: "ros-shop",
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.container {
  margin: 20px auto;
  text-align: initial;
  max-width: 1200px;
  font-family: 宋体;
  font-size: 14px;
  height: auto;
  padding: 0 20px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
}
p {
  line-height: 35px;
  color: #333;
  margin: 8px 0;
}
@media (max-width: 768px) {
  .container {
    font-size: 12px;
    color: #555;
    width: 94%;
    margin: 10px auto;
    padding: 0 3%;
  }
}
</style>
